import React from 'react';
import { PCFWorkspace } from '../modules/pcf/PCFWorkspace';

export default function PCFStudio() {
  return <PCFWorkspace />;
}